import { render, staticRenderFns } from "./FavoriteContents.vue?vue&type=template&id=57beb9ae&scoped=true&"
import script from "./FavoriteContents.vue?vue&type=script&lang=js&"
export * from "./FavoriteContents.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteContents.vue?vue&type=style&index=0&id=57beb9ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57beb9ae",
  null
  
)

export default component.exports